import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

import useStyles from './styles';

const CertificateFooter = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.wrapFooter}>
      <div className={classes.itemFooter}>
        <Text className={classes.title}>Gladius Art</Text>

        <Text className={classes.textFooter}>gladiusart.com</Text>
        <Text className={classes.textFooter}>{t('text_certificate_address')}</Text>
        <Text className={classes.textFooter}>[+84] 566024888</Text>
        <Text className={classes.textFooter}>contact@gladiusart.com</Text>
        <Text className={classes.textFooter}>{t('all_rights_reserved')}</Text>
      </div>
    </Box>
  );
};

export default CertificateFooter;
